import { Spinner, Form } from "react-bootstrap";
import { FieldErrors, UseFormRegister } from "react-hook-form";
import { useState } from "react";
import { useGrupos, ActiveFilters } from "services/grupo";
import { usePermissionModal } from "contexts/PermissionModalContext";

interface GrupoSelectProps {
  register: UseFormRegister<any>;
  errors: FieldErrors;
  isDisabled?: boolean;
  required?: boolean;
}

const GrupoSelect = ({ 
  register, 
  errors, 
  isDisabled = false, 
  required = true 
}: GrupoSelectProps) => {
  const { showPermissionModal } = usePermissionModal();
  
  // Add pagination state
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 100 // Fetch more groups at once since this is for a dropdown
  });
  
  // Default filter state to show only active groups
  const filterState = {
    active: { groupStatus: "active" } as ActiveFilters
  };
  
  const gruposQuery = useGrupos(
    "",
    filterState.active,
    pagination.pageIndex + 1,
    pagination.pageSize,
  );

  // Handle select click when there's a permission error
  const handleSelectClick = () => {
    showPermissionModal("Você não possui permissão para consultar ou visualizar grupos de acesso.");
  };
  
  return (
    <>
      <Form.Group controlId="grupoId">
        <Form.Label>
          Grupo de Usuários {required && <span className="text-danger">*</span>}
        </Form.Label>
        {gruposQuery.isLoading ? (
          <div className="d-flex align-items-center">
            <Spinner size="sm" animation="border" className="me-2" />
            <span>Carregando grupos...</span>
          </div>
        ) : gruposQuery.isError ? (
          <Form.Select
            {...register("grupoId", {
              required: required ? "Grupo é obrigatório" : false,
            })}
            isInvalid={!!errors.grupoId}
            disabled={isDisabled}
            onClick={handleSelectClick}
            style={{ cursor: "pointer" }}
          >
            <option value="">Selecione um grupo</option>
          </Form.Select>
        ) : (
          <Form.Select
            {...register("grupoId", {
              required: required ? "Grupo é obrigatório" : false,
            })}
            isInvalid={!!errors.grupoId}
            disabled={isDisabled}
            className={isDisabled ? "bg-gray-100" : ""}
            style={isDisabled ? { opacity: 0.9 } : {}}
          >
            <option value="">Selecione um grupo</option>
            {gruposQuery?.data?.data?.map((grupo: any) => (
              <option key={grupo.id} value={grupo.id}>
                {grupo.codigo} - {grupo.descricao}
              </option>
            ))}
          </Form.Select>
        )}
        <Form.Control.Feedback type="invalid">
          {errors.grupoId?.message as string}
        </Form.Control.Feedback>
      </Form.Group>
    </>
  );
};

export default GrupoSelect;
